import type React from "react";

const EventReport: React.FC = () => {
	return (
		<section className="py-16 bg-gray-100">
			<div className="container mx-auto">
				<h2 className="text-3xl font-bold text-center mb-12">
					イベントレポート
				</h2>
				<div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
					<EventCard
						title="春期成果発表会"
						date="2023年6月30日"
						description="受講生たちが3ヶ月間の学習の成果を発表しました。多くの素晴らしいプロジェクトが披露されました。"
						imageUrl="/images/event-report-1.jpg"
					/>
					<EventCard
						title="企業との交流会"
						date="2023年5月15日"
						description="IT企業の方々をお招きし、受講生とのネットワーキングイベントを開催しました。キャリアについての貴重なアドバイスが得られました。"
						imageUrl="/images/event-report-2.jpg"
					/>
					<EventCard
						title="ハッカソン"
						date="2023年4月22日〜23日"
						description="48時間のハッカソンを開催。チームで協力して革新的なプロジェクトを作り上げました。"
						imageUrl="/images/event-report-3.jpg"
					/>
				</div>
			</div>
		</section>
	);
};

interface EventCardProps {
	title: string;
	date: string;
	description: string;
	imageUrl: string;
}

const EventCard: React.FC<EventCardProps> = ({
	title,
	date,
	description,
	imageUrl,
}) => {
	return (
		<div className="bg-white rounded-lg shadow-md overflow-hidden">
			<img src={imageUrl} alt={title} className="w-full h-48 object-cover" />
			<div className="p-6">
				<h3 className="text-xl font-semibold mb-2">{title}</h3>
				<p className="text-gray-600 mb-2">{date}</p>
				<p className="text-gray-700">{description}</p>
			</div>
		</div>
	);
};

export default EventReport;
